(function($, undefined) {
	'use strict';
    var manageMerchsPath = "/action/epManageProducts";
    var picture;
    var pictureFile;
    var delPicture;
    var activateOptions;
    var addOptionBtn;
    var addOptionDelBtn;
    var optionEditQty;
    var originalInventory;
    var pauseProductBtn;
    var archiveProductBtn;
    var confirmArchivePopupBtn;
    var confirmArchiveBtn;
    var duplicateProductBtn;
    var linkEventProductBtn;
    var linkEventProductDeleteBtn;
    var linkEventProductVisibilityBtn;
    var merchId;
    var submitCreateProductBtn;
    var statusChangeBtn;
    var doNotBuyTicketCheckbox;
    var availableQtyInput;

    var triggerFileSelection = function(e){
        var t = $(this);
        var f = t.next();
        f.click();
    };
    
    var getThumbnail = function(e){
        var file = this.files[0];
        var reader = new FileReader();
        var ctn = $(this).prev();
        var preview = ctn.find(".home-event-bg-pic");
        
        reader.onloadend = function (e) {
            ctn.removeClass("empty");
            preview.removeClass("home-event-bg-pic-hide");
            if(ctn.find(".featured-event-delete").hasClass("rotate")){
                deleteImage(e, ctn.find(".featured-event-delete"));
            }
            preview.css("backgroundImage","url("+reader.result+")");
        };

        if (file) {
            reader.readAsDataURL(file);
        } else {
            preview.css("");
        }
    };
    
    var deleteImage = function(e, th){
        e.stopPropagation();
        var t = (th !== undefined) ? th : $(this);
        var inp = t.find(".delete-pic");
        var img = t.parent().find(".home-event-bg-pic");
        if(t.hasClass("rotate")){
            t.removeClass("rotate");
            inp.attr("name", "");
            img.removeClass("to-be-deleted");
        } else {
            t.addClass("rotate");
            inp.attr("name", inp.attr("data-name"));
            img.addClass("to-be-deleted");
        }
    };
    
    var deleteMerch = function() {
        var btnDel = $(this),
        data = {item: btnDel.closest("tr")},
        btnYes = $("#deleteMerchConfirmPopup .popup-btn-confirm"),
        btnNo = $("#deleteMerchConfirmPopup .popup-btn-cancel");
        btnYes.one("click", data, function(e){confirmDeleteMerch(e);});
        btnNo.one("click", function(e) {
            btnYes.off("click", confirmDeleteMerch);
            closeWindow("deleteMerchConfirmPopup");
        });
        $("#deleteMerchConfirmPopup").css("position", "absolute");
        openWindow("deleteMerchConfirmPopup", true);
    };
    
    var confirmDeleteMerch = function(e) {
        e.stopImmediatePropagation();
        var item = e.data.item,
        merchid = item.attr("data-merchid");

        var data = new FormData();
        data.append("productId", merchid);
        data.append("delete", "true");
        data.append("ajax", "true");
        
        $.ajax({
            url: manageMerchsPath,
            data: data,
            cache: false,
            contentType: false,
            processData: false,
            type: 'POST',
            success: function(response) {                
                if (response.trim()!== "fail") {
                    item.remove();
                }
            }
        });
        closeWindow("deleteMerchConfirmPopup");
    };
    
    var addOption = function(){
        var ctn = $(".add-option-form");
        var name = ctn.find("input[name='optionName']").val();
        var qty = ctn.find("input[name='optionQty']").val();
        
        if(name !== '' && qty !== ''){
            var count = parseInt($(".create-product-all-custom-quantities input[name='optionCounter']").val()) + 1;
            
            var clone = $("#product-options-clone").children().clone();
            clone.find("input.product-custom-name").val(name);
            clone.find("input.product-custom-name").attr("name", "optionName"+count);
            clone.find(".create-product-custom-qty-name").text(name);
            clone.find("input.product-custom-qty").val(qty);
            clone.find("input.product-custom-qty").attr("name", "optionQty"+count);
            clone.find(".remove-product-custom-qty-btn").on("click",function(e){removeOption(e, this);});
            
            $(".options-ctn").append(clone);
            $(".create-product-all-custom-quantities input[name='optionCounter']").val(count);
            ctn.find("input[name='optionName']").val("").closest('.input-ctn').removeClass('focused');
            ctn.find("input[name='optionQty']").val("").closest('.input-ctn').removeClass('focused');
            $(".create-product-options-ctn").find('.derequired').removeClass('required');
            updateMerchQty();
        }
    };
    
    var removeOption = function(e, th){
        var t = (th === undefined) ? $(this) : $(th);
        var ctn = t.closest('.create-product-options-ctn');
        if(t.closest(".create-product-custom-qty-ctn").find(".product-custom-remove").length !== 0){
            var inp = t.closest(".create-product-custom-qty-ctn").find(".product-custom-remove");
            inp.attr("name", inp.attr("data-name"));
            t.closest(".create-product-custom-qty-ctn").addClass("hide");
        }else{
            t.closest(".create-product-custom-qty-ctn").remove();
        }
        if (ctn.find('.options-ctn').find('.create-product-custom-qty-ctn.filled:not(.hide)').length === 0) {
            ctn.find('.derequired').addClass('required');
        }
        updateMerchQty();
    };
    
    var handleOptions = function(e){
        var check = $(this).is(":checked");
        var optionsCtn = $(".create-product-options-ctn");
        var inventoryInput = $(".add-product-form input[name = 'inventory']");
        var optionInventoryInput = $(".add-product-form  .available-options-qty");
        
        if(check){
            optionsCtn.slideDown();
            inventoryInput.parent().addClass("disabled-ctn");
            inventoryInput.addClass("disabled");
            inventoryInput.attr("disabled", "disabled");
            originalInventory = inventoryInput.val();
            if (optionsCtn.find('.options-ctn').find('.create-product-custom-qty-ctn.filled:not(.hide)').length === 0) {
                optionsCtn.find('.derequired').addClass('required');
            }
            optionInventoryInput.attr("name", optionInventoryInput.attr("data-name"));
            updateMerchQty();
        } else {
            optionsCtn.slideUp();
            inventoryInput.parent().removeClass("disabled-ctn");
            inventoryInput.removeAttr("disabled");
            inventoryInput.removeClass("disabled");
            optionsCtn.find('.derequired').removeClass('required').removeClass('error');
            inventoryInput.val(originalInventory);
            optionInventoryInput.attr("name", "");
        }
    };
    
    var updateMerchQty = function (e) {
        var optionInventoryInput = $(".add-product-form  .available-options-qty");
        var inventory = $(".add-product-form input[name = 'inventory']");
        var total = 0;
        
        $(".create-product-custom-qty-ctn:not(.hide) .product-custom-qty").each(function(){
            total += parseInt($(this).val());
        });
        
        inventory.val(total);
        optionInventoryInput.val(total);
        
    };
    
    var pauseProduct = function(){
        var t = $(this);
        var row = t.closest('tr');
        var id = t.attr("data-id");
        var active = !t.hasClass("active");
        
        var data = new FormData();
        data.append("productId", id);
        data.append("active", active);
        data.append("ajax", "true");

        var url = "/action/epManageProducts";
        
        $.ajax({
            url: url,
            data: data,
            cache: false,
            contentType: false,
            processData: false,
            type: 'POST',
            success: function (response) {
                var actionBtns = row.find('.table-suspend-product-sale-action');
                if (active) {
                    actionBtns.addClass("active");
                    actionBtns.find("p").text(t.find("p").attr("data-active"));
                } else {
                    actionBtns.removeClass("active");
                    actionBtns.find("p").text(t.find("p").attr("data-inactive"));
                }
            }
        });
    };
    
    var archiveProduct = function(btn){
        var t = $(this).length > 0 ? $(this) : btn;
        var id = t.attr("data-id");
        var archive = !t.hasClass("archived");
        var forward = t.attr("data-url");
        
        var data = new FormData();
        data.append("productId", id);
        data.append("archive", archive);
        data.append("ajax", "true");

        var url = "/action/epManageProducts";
        
        $.ajax({
            url: url,
            data: data,
            cache: false,
            contentType: false,
            processData: false,
            type: 'POST',
            success: function (response) {      
                window.location = forward;
//                if (archive) {
//                    t.addClass("archived");
//                    t.find("p").text(t.find("p").attr("data-unarchive"));
//                } else {
//                    t.removeClass("archived");
//                    t.find("p").text(t.find("p").attr("data-archive"));
//                }
            }
        });
    };

    var confirmArchivePopup = function() {
        merchId = $(this).closest('tr').attr('data-merchid');
        openWindow("archive-product-warning-popup", true);
    };

    var archiveAfterConfirm = function() {
        var archiveBtn = $('tr[data-merchid=' + merchId + ']').find('.product-archive-action');
        archiveProduct(archiveBtn);
    };
    
    var duplicateProduct = function(){
        var t = $(this);
        var id = t.attr("data-id");
        var forward = t.attr("data-url");
        
        var data = new FormData();
        data.append("productId", id);
        data.append("duplicate", "true");
        data.append("ajax", "true");

        var url = "/action/epManageProducts";
        
        $.ajax({
            url: url,
            data: data,
            cache: false,
            contentType: false,
            processData: false,
            type: 'POST',
            success: function (response) {
                if (response.indexOf("success") !== -1) {
                    var id = response.trim().substring(8);
                    window.location = forward + "?productId=" + id;
                }
            }
        });
    };
    
    var linkEventProduct = function(){
        var ctn = $(".create-event-product-link-form");
        var eventId = ctn.find("input[name='link-event-product-eventId']").val();
        var productId = ctn.find("select[name='product-selection']").val();
        var doNotBuyTicket = ctn.find("input[name='event-product-purchase-condition']").is(":checked");
        if(productId !== ''){
            var url = "/action/epManageEventProducts";
            url += "?productId="+productId;
            url += "&eventId="+eventId;
            url += "&buyTicket="+!doNotBuyTicket;
            ajax(url, function(response){
                if(response.indexOf("success") !== -1){
                    var id = response.trim().substring(8);
                    var clone = $(".event-form-products-table-bank .event-product-"+productId);
                    $(".event-form-products-table-bank .event-product-"+productId);
                    var counter = parseInt($(".event-product-position-counter").val()) + 1;
                    clone.find(".event-product-position").text(counter);
                    $(".event-product-position-counter").val(counter);
                    
                    clone.find(".event-product-delete-link").attr("data-id", id);
                    clone.find(".event-product-delete-link").attr("data-buyticket", !doNotBuyTicket);
                    clone.attr("data-linkid", id);
                    if(doNotBuyTicket){
                        clone.find(".table-product-qr-icon-ctn").addClass("hide");
                    } else {
                        clone.find(".table-product-qr-icon-ctn").removeClass("hide");                        
                    }
                    
                    $(".event-form-products-table").append(clone);
                    $(".link-products-choice-"+productId).addClass("hide");
                    ctn.find("select[name='product-selection']").val("");
                    ctn.find("input[name='event-product-purchase-condition']").prop("checked", false);
                }
            }, true);
        }
    };
    
    var closeClonePopup = function(ctn){
        var rowActionButtons = ctn.find('.table-action-popup-btn');
        var actionsPopup = ctn.find('.table-actions-ctn');
        rowActionButtons.removeClass('active');
        ctn.find('.table-cell-overlay').removeClass('active');
        ctn.find('.table-cell-overlay').attr("style","display: none;");
        actionsPopup.removeClass('open');

        var parent = ctn.find('.table-action-btns-ctn');
        if (!parent.is('div')) {
            $('.overlay', 'body').removeClass('active-responsive');
        }
    };
    
    var linkEventProductDelete = function(){
        var t = $(this);
        var ctn = $(".create-event-product-link-form");
        var eventId = ctn.find("input[name='link-event-product-eventId']").val();
        var productId = t.attr("data-productid");
        var linkId = t.attr("data-id");
        var table = t.closest('tbody');
        if(linkId !== ''){
            var url = "/action/epManageEventProducts";
            url += "?linkId=" + linkId;
            url += "&productId=" + productId;
            url += "&eventId=" + eventId;
            url += "&delete=true";
            ajax(url, function(response){
                if(response.indexOf("success") !== -1){
                    var clone = t.closest("tr");
                    var counter = parseInt($(".event-product-position-counter").val()) - 1;
                    $(".event-product-position-counter").val(counter);
                    $(".event-form-products-table-bank").append(clone);
                    $(".link-products-choice-"+productId).removeClass("hide");
                    closeClonePopup(clone);
                    updatePositionMerch();
                    if (table.find('.event-product-delete-link[data-buyticket=false]').length === 0) {
                        $('.postal-delivery-checkbox-ctn').removeClass('fade no-pointer');
                    }
                }
            }, true);
        }
    };
    
    var updatePositionMerch = function(){
        $(".event-form-products-table tr").each(function(index){
            $(this).find(".event-product-position").text(index);
        });
    };
    
    var toggleEventProductVisibility = function(){
        var t = $(this);
        var ctn = $(".create-event-product-link-form");
        var eventId = ctn.find("input[name='link-event-product-eventId']").val();
        var productId = t.attr("data-productid");
        var linkId = t.attr("data-id");
        var visible = !t.hasClass("active");
        if(linkId !== '') {
            var url = "/action/epManageEventProducts";
            url += "?linkId=" + linkId;
            url += "&productId=" + productId;
            url += "&eventId=" + eventId;
            url += "&visible=" + visible;
            ajax(url, function(response){
                if(response.indexOf("success") !== -1){
                    if(visible){
                        t.addClass("active");
                        t.find("p").text(t.find("p").attr("data-visible"));
                    } else{
                        t.removeClass("active");
                        t.find("p").text(t.find("p").attr("data-invisible"));
                    }
                }
            }, true);
        }
    };

    var validateProductForm = function(e) {
        var btn = $(this);
        var form = $(this).closest('form');
        var mainImgCtn = $('.create-product-img-ctn.main');
        var error = $('.js-form-error-message.image');

        e.preventDefault();
        formValidator.validateForm(form);

        if (mainImgCtn.hasClass('empty') || mainImgCtn.find('.home-event-bg-pic').hasClass('to-be-deleted')) {
            form.addClass('error-img');
            mainImgCtn.addClass('error');
            error.slideDown();
        } else {
            form.removeClass('error-img');
            mainImgCtn.removeClass('error');
            error.slideUp();
        }

        if (!form.hasClass('has-error') && !form.hasClass('error-img')) {
            btn.addClass('disabled');
            form.submit();
        }
    };
    
    var changePaymentStatus = function(){
        var t = $(this);
        var ctn = t.closest(".product-sales-status-popup");
        var id = t.attr("data-id");
        var radio = ctn.find("input[name = 'product-status-"+id+"']:checked");
        var status = radio.val();
        var mode = radio.attr("data-extra");
        
        var url = "/action/epManageTransactions";
        url += "?paymentId=" + id;
        url += "&shippingMode=" + mode;
        url += "&status=" + status;
        ajax(url, function (response) {
            if (response.indexOf("success") !== -1) {
                $(".merch-payments-"+id).find(".table-status-text").text(radio.parent().find(".radio-input-text").text());
                var colorBar = $(".merch-payments-"+id).find(".table-status-colorbar");
                if(status === '2' || status === '3' || status === '4'){
                    colorBar.removeClass("yellow");
                    colorBar.removeClass("orange");
                    colorBar.addClass("green");
                } else if(status === '1'){
                    colorBar.removeClass("green");
                    colorBar.removeClass("orange");
                    colorBar.addClass("yellow");                    
                } else {
                    colorBar.removeClass("yellow");
                    colorBar.removeClass("green");
                    colorBar.addClass("orange");                    
                }
            }
        }, true);
    };

    var toggleShippingCheckbox = function() {
        var t = $(this);
        var postalDelivery = $('input[name=postalDelivery]');

        if (t.is(':checked')) {
            if (!postalDelivery.is(':checked')) {
                postalDelivery.trigger('click');
            }
            $('.postal-delivery-checkbox-ctn').addClass('fade no-pointer');
        } else {
            if ($('.event-form-products-table').find('.event-product-delete-link[data-buyticket=false]').length === 0) {
                $('.postal-delivery-checkbox-ctn').removeClass('fade no-pointer');
            }
        }
    };

    var checkInventoryVsAvailable = function() {
        var t = $(this);

        if (t.val() < t.data('misc')) {
            t.val(t.data('misc'));
        }
    };

    var maxProductPrice = function() {
        var t = $(this);
        if (parseInt(t.val()) > 10000) {
            t.val(10000);
        }
    };

    var init = function () {
        originalInventory = $(".add-product-form input[name = 'inventory']").val();
        
        delPicture = $(".create-product-img-ctn .featured-event-delete");
        delPicture.on("click", deleteImage);
        
        picture = $(".create-product-img-ctn");
        picture.on("click", triggerFileSelection);
        
        pictureFile = $(".select-picture");
        pictureFile.on("change", getThumbnail);
        
        $(".merch-table .table-delete-btn").click(deleteMerch);
        
        activateOptions = $(".add-product-form input[name = 'optionsActive']");
        activateOptions.on("click", handleOptions);
        
        addOptionBtn = $(".create-product-add-option-btn");
        addOptionBtn.on("click", addOption);
        
        addOptionDelBtn = $(".remove-product-custom-qty-btn");
        addOptionDelBtn.on("click", removeOption);
        
        optionEditQty = $(".product-custom-qty");
        optionEditQty.on("change", updateMerchQty);
        
        pauseProductBtn = $(".table-suspend-product-sale-action");
        pauseProductBtn.on("click", pauseProduct);
        
        archiveProductBtn = $(".product-archive-action:not(.has-linked-events)");
        archiveProductBtn.on("click", archiveProduct);
        
        confirmArchivePopupBtn = $(".product-archive-action.has-linked-events");
        confirmArchivePopupBtn.on("click", confirmArchivePopup);
        
        confirmArchiveBtn = $(".confirm-archive-btn");
        confirmArchiveBtn.on("click", archiveAfterConfirm);
        
        duplicateProductBtn = $(".product-duplicate-btn");
        duplicateProductBtn.on("click", duplicateProduct);
        
        linkEventProductBtn = $(".add-product-choice-btn");
        linkEventProductBtn.on("click", linkEventProduct);
        
        linkEventProductDeleteBtn = $(".event-product-delete-link");
        linkEventProductDeleteBtn.on("click", linkEventProductDelete);
        
        linkEventProductVisibilityBtn = $(".event-product-visibility-btn");
        linkEventProductVisibilityBtn.on("click", toggleEventProductVisibility);
    
        submitCreateProductBtn = $('.submit-create-product-btn');
        submitCreateProductBtn.click(validateProductForm);
        
        statusChangeBtn = $('.status-payment-change-btn');
        statusChangeBtn.click(changePaymentStatus);

        doNotBuyTicketCheckbox = $("input[name='event-product-purchase-condition']");
        doNotBuyTicketCheckbox.click(toggleShippingCheckbox);

        availableQtyInput = $('.merch-available-qty');
        availableQtyInput.keyup(checkInventoryVsAvailable);

        $('.product-price-input').keyup(maxProductPrice);
    };

    $(window).on('load', function () {
        init();
    });

})(jQuery);